module.exports = "fragment PlanFeatureIcon on PlanFeatureIcon {\n  title\n}\n"